import React from "react";
import * as R from "ramda";
import CSSModules from "react-css-modules";
import css from "./styles.scss";

import TimelapseOutlined from "@material-ui/icons/TimelapseOutlined";
import CheckCircle from "@material-ui/icons/CheckCircle";
import FiberManualRecordOutlinedIcon from "@material-ui/icons/FiberManualRecordOutlined";

import { actions as sliderSidebarActions } from "Portal/NewPortal/Sections/Sessions/FlyOver/model";
import { connect } from "react-redux";

export const StatusComponent = ({ status, className }) =>
  R.propOr(
    <CheckCircle className={className} style={{ color: "#51CF66" }} />,
    status,
    {
      approved: (
        <CheckCircle className={className} style={{ color: "#51CF66" }} />
      ),
      pending: (
        <TimelapseOutlined className={className} style={{ color: "#FF922B" }} />
      ),
      rejected: (
        <FiberManualRecordOutlinedIcon
          className={className}
          style={{ color: "#FF6B6B" }}
        />
      ),
      declined: (
        <FiberManualRecordOutlinedIcon
          className={className}
          style={{ color: "#FF6B6B" }}
        />
      ),
      null: <>-</>
    }
  );

const decorate = R.compose(
  connect(null, {
    openSessionFlyover: sliderSidebarActions.openSessionFlyover
  }),
  CSSModules(css)
);

const Application = data => {
  return (
    <div
      className={[css.sessionContainer, "accentable-hover"].join(" ")}
      onClick={() => {
        window.location = `/applications/${data.slug}/${data.formId}/submissions/${data.id}`;
      }}
    >
      <div className={css.sessionContent}>
        <div className={css.sessionHeader}>
          <div className={css.sessionTitle}>{data.name}</div>
        </div>
        <div className={css.sessionStatusContainer}>
          <div className={css.sessionStatus}>
            <div className={css.statusIcon}>
              <StatusComponent
                className={css.statusIndicator}
                status={data.status}
              />
            </div>
            <div className={css.statusText}>{data.open_label}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default decorate(Application);
